import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Open dock lean-to — three plank walls + mono-pitch roof (landmark deco).
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
  const plank = shade(0x9c7b4f, (rand(seed) - 0.5) * 0.1);
  const dk = shade(plank, -0.18);
  const roof = shade(0x4a3a28, (rand(seed + 1) - 0.5) * 0.08);
  const hw = 1.8, hd = 1.5, wallH = 2.4;
  // Floor
  box(0, 0.08, 0, hw * 2, 0.16, hd * 2, plank);
  // Back (+z) wall
  box(0, wallH / 2, hd - 0.1, hw * 2, wallH, 0.2, plank);
  // Left wall
  box(-hw + 0.1, wallH / 2, 0, 0.2, wallH, hd * 2 - 0.2, plank);
  // Right wall
  box(hw - 0.1, wallH / 2, 0, 0.2, wallH, hd * 2 - 0.2, plank);
  // Corner posts
  for (const sx of [-1, 1]) {
    for (const sz of [-1, 1]) {
      box(sx * (hw - 0.12), wallH / 2 + 0.1, sz * (hd - 0.12), 0.22, wallH + 0.2, 0.22, dk);
    }
  }
  // Mono-pitch roof (high at back, low at open front −z)
  box(0, wallH + 0.15, 0.15, hw * 2 + 0.5, 0.18, hd * 2 + 0.5, roof);
  box(0, wallH + 0.35, 0.35, hw * 2 + 0.3, 0.14, hd * 1.6, shade(roof, -0.1));
  // Interior crate silhouette
  box(0.6, 0.45, 0.5, 0.7, 0.7, 0.7, dk);
  box(-0.5, 0.5, 0.4, 0.45, 0.9, 0.45, shade(plank, -0.08));
};

export default build;
